import React, { Component } from "react";
import Teletype, { ITeletypeData } from "./Teletype";

export interface IScreenProps {
    data: IScreenData;
    previous: string;
    onChangeScreen: (id: string) => void;
    width?: number;
    sound: boolean;
}

export interface IScreenData {
    id: string;
    content: ITeletypeData[];
    main?: boolean;
}

export interface IScreenLink {
    target: number;
    label: string;
}

interface IScreenState {
    renderMore: boolean;
    renderBack: boolean;
}

class Screen extends Component<IScreenProps, IScreenState> {
    private _main: boolean;
    private _ref: React.RefObject<HTMLDivElement>;

    constructor(props: IScreenProps) {
        super(props);

        this.state = {
            renderMore: false,
            renderBack: false,
        };

        this._main = !!this.props.data.main;
        this._ref = React.createRef();

        this._onTeletypeDone = this._onTeletypeDone.bind(this);
        this._onScroll = this._onScroll.bind(this);
    }

    public componentDidUpdate(prevProps: IScreenProps, prevState: IScreenState) {
        if (prevProps.data !== this.props.data) {
            this._reset();
        }
    }

    public render() {
        const {
            data,
            previous,
            onChangeScreen,
            width,
            sound,
        } = this.props;
        
        // screen width hasn't been calculated yet;
        // nothing to render
        if (!width) {
            return <div />;
        }

        const style: React.CSSProperties = {
            width,
        };

        return (
            <section className="screen" style={style} ref={this._ref}>
                <Teletype
                    data={data.content}
                    autostart={true}
                    sound={sound}
                    onDone={this._onTeletypeDone}
                    onNavigate={onChangeScreen}
                    onScroll={this._onScroll}
                />

                { this.state.renderBack && this._renderBackButton() }
            </section>
        );
    }

    private _onTeletypeDone(): void {
        this.setState({
            renderBack: true,
        });
    }

    private _renderBackButton(): React.ReactNode {
        if (!this.state.renderBack || this._main) {
            return null;
        }

        const {
            data,
            previous,
            onChangeScreen,
        } = this.props;

        if (!previous || data.id === previous) {
            return;
        }

        const backData = [
            {
                text: "",
                target: null,
            },
            {
                text: "[Back]",
                target: previous,
            },
        ];

        return (
            <Teletype
                data={backData}
                autostart={true}
                onDone={null}
                onNavigate={onChangeScreen}
            />
        )
    }

    private _reset(): void {
        this.setState({
            renderBack: false,
            renderMore: false,
        });

        this._main = !!this.props.data.main;
    }

    private _onScroll(value: number): void {
        const ref = this._ref;
        if (ref) {
            ref.current.scrollTop = value;
        }
    }
}

export default Screen;
